import { render, staticRenderFns } from "./searchHistory.vue?vue&type=template&id=353325de&scoped=true"
import script from "./searchHistory.vue?vue&type=script&lang=js"
export * from "./searchHistory.vue?vue&type=script&lang=js"
import style0 from "./searchHistory.vue?vue&type=style&index=0&id=353325de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353325de",
  null
  
)

export default component.exports